const PRODUCTION = window.location.href

export const DEFAULT_API_URLS = {
  LOCAL: 'http://192.168.3.2/Desenv/Oliveira/Signa.Login.Api/',
  PRODUCTION: `${PRODUCTION}api/`,
  DEVELOPMENT: 'http://192.168.3.2/Desenv/Oliveira/Signa.Login.Api/'
}
